import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadDesignSystem } from './ds';
import { RouterProvider } from './router';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

const root = createRoot(container);

// The design system bundle registers its components on a global and every page
// renders them, so mounting before it resolves would throw. Waiting here keeps
// every component free of load-state checks.
loadDesignSystem()
  .then(() => {
    root.render(
      <React.StrictMode>
        <RouterProvider>
          <App />
        </RouterProvider>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error(err);
    root.render(
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: 40,
          background: 'var(--app-ground)',
          fontFamily: 'var(--font-body)',
          textAlign: 'center'
        }}
      >
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28 }}>Something did not load.</h1>
          <p style={{ color: 'var(--text-muted)', maxWidth: 440 }}>Reload the page to try again.</p>
        </div>
      </div>
    );
  });
